import React from "react";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";

function MiscPageTitle(props) {
  return (
    <div className="container text-center" style={{ marginTop: "6rem" }}>
      <div>
        {/* Log event */}
        {/*Firebase analytics */}
        {logEvent(analytics, props.title)}

        {/* Title */}
        <h1 className="display-5 fw-bold text-success">
          {props.title} {props.online ? "" : "(Offline)"}
        </h1>
      </div>
      <div>
        <label
          className={`lead text-secondary text-muted mt-2 fs-6 ${
            props.online === false ? "" : "d-none"
          }`}
        >
          This app runs completely on your device, none of your files are
          uploaded to any of our servers. So your privacy is always protected.
        </label>
      </div>
    </div>
  );
}

export default MiscPageTitle;
